import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { SearchActions } from 'src/app/common/store/actions/search.actions';
import { selectAllSearchedDealersPreviewTotalCount, selectDealerCriteria, selectSearchFetchingPreview } from 'src/app/common/store/state/app.state';
import { Observable } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';

import { DateRange } from '@angular/material/datepicker';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { AsyncPipe } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppConstants } from 'src/app/public/common/constants/app-constants';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBasicData } from 'src/app/public/car/constants/car-basic-data';
import { CommonBasicData } from 'src/app/public/common/constants/common-basic-data';
import { GeneralBasicData } from 'src/app/public/common/constants/general-basic-data';
import { Country } from 'src/app/public/common/models/country.model';
import { DealerCriteria } from '../../models/dealer-criteria.model';



@Component({
    selector: 'app-dealer-search-criteria',
    templateUrl: './dealer-search-criteria.component.html',
    styleUrls: ['./dealer-search-criteria.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule, MatProgressSpinnerModule, MatIconModule, MatDividerModule, AsyncPipe, MatSelectModule]
})
export class DealerSearchCriteriaComponent implements OnInit{

  disabled = false;

  //businessLinesBD : string [] = [CarBusinessLine.SALE, CarBusinessLine.RENTAL];
  
  //selectedBusinessLine: string = CarBusinessLine.SALE;
  //@Input() selectedBusinessLine?: CarBusinessLine;
  
  pMin = 0; 
  pMax = 0; 
  step = 1; 
  
  yMin = AppConstants.CAR_YEAR_MIN;
  yMax = new Date().getFullYear();

  showTicks = false;
  
  thumbLabel = true;
  value = 0;

  gearboxesBD = CarBasicData.gearboxes;
  fuelTypesBD = CarBasicData.fuelTypes;
  seviceTypesBD = CommonBasicData.serviceTypes
  
  carMakesBD: string [] = [];
  carModelsBD: string [] = [];

  countriesBD: Country [] = [];
  citiesBD: string [] = [];

  todayDate: Date;
  tomorrowDate: Date;
  yesterdayDate: Date;
  selectedDateRange: DateRange<Date>;

  //showCriteriaPanel: boolean = true;
  showCriteriaPanel: boolean = (window.innerWidth > AppConstants.SCREEN_BREAK_L);

  dealerCriteria: DealerCriteria = new DealerCriteria();

  fetchingPreview$: Observable<boolean>;
  previewTotalCount$: Observable<number>;

  dealerCriteria$: Observable<DealerCriteria>;
  
  //selectedCountryCodes$: Observable<string[]>;
  //selectedCountryCodes: string[] = [];
  selectedCountryCodes: string[] = [];


  countryCodeOptions: string[] = AppConstants.COUNTRY_CODE_OPTIONS;

  constructor(
    private store: Store,
    private router: Router, 
    private route: ActivatedRoute) {
      this.fetchingPreview$ = store.select(selectSearchFetchingPreview);
      this.previewTotalCount$ = store.select(selectAllSearchedDealersPreviewTotalCount);
      this.dealerCriteria$ = store.select(selectDealerCriteria);
      //this.selectedCountryCodes$ = store.select(selectSelectedCountryCodes);

      this.todayDate = new Date();
      this.tomorrowDate = new Date(this.todayDate);
      this.yesterdayDate = new Date(this.todayDate);

      this.tomorrowDate.setDate(this.todayDate.getDate()+1);
      this.yesterdayDate.setDate(this.todayDate.getDate()-1);

      this.selectedDateRange = new DateRange<Date>(this.todayDate, this.tomorrowDate);

    //this.dealerCriteria.startDate = new Date(this.todayDate).toISOString();
    //this.dealerCriteria.endDate = new Date(this.tomorrowDate).toISOString();
  
    }

  ngOnInit(): void {

    console.log('dates = '+this.dealerCriteria.minCreatedDate)

    //this.dealerCriteria.priceMin = this.pMin;
    //this.dealerCriteria.priceMax = this.pMax;
    //this.dealerCriteria.businessLines = [this.selectedBusinessLine!.toString()];
    
    this.carMakesBD = CarBasicData.getMakesBD();
    this.countriesBD = GeneralBasicData.getAllCountries();

    this.dealerCriteria$.subscribe(criteria => {

      this.dealerCriteria = JSON.parse(JSON.stringify(criteria));
      //this.selectedCountryCodes = this.dealerCriteria.countries;
      this.selectedCountryCodes = this.dealerCriteria.countries;
      //this.dealerCriteria.businessLines = [this.selectedBusinessLine!];
      
      this.updateModelsBD();
      this.updateCitiesBD();

      this.store.dispatch(SearchActions.dealersPreviewCriteriaSubmit({dealerCriteria: JSON.parse(JSON.stringify(this.dealerCriteria))}));
   
    });

  }

  updateModelsBD(): void{

    //this.carModelsBD = CarBasicData.getModelsBD(this.dealerCriteria.makes);
   
  }

  updateCitiesBD(): void{

    //this.citiesBD = GeneralBasicData.getAllCities(this.dealerCriteria.countries);
    this.citiesBD = GeneralBasicData.getAllCities(this.selectedCountryCodes);
   
  }

  updateModelsSelector(): void{
    //this.dealerCriteria.models = [];
    //this.carModelsBD = CarBasicData.getModelsBD(this.dealerCriteria.makes);
  }

  updateCitiesSelector(): void{
    this.dealerCriteria.cities = [];
    this.citiesBD = GeneralBasicData.getAllCities(this.dealerCriteria.countries);
  }

  onMakeChange(event: MatSelectChange){
    this.dealerCriteria.specialtyMakes = [event.value];
    this.updateModelsSelector(); 
    this.onCriteriaChange()
  }

  onServiceProvidedChange(event: MatSelectChange){
    this.dealerCriteria.servicesProvided = [event.value];
    this.onCriteriaChange()
  }

  onCriteriaChange() {
    console.log(this.dealerCriteria);
    this.submitSearchPreview();
  }

  formatSliderLabel(value: any): string {

    return AppFunctions.numberWithSpaces(""+value);
  }

  submitSearchPreview(){
    //this.dealerCriteria.specialtyMakesthis.dealerCriteria.specialtyMakes]
    console.log(this.dealerCriteria.specialtyMakes)
    this.store.dispatch(SearchActions.dealersPreviewCriteriaSubmit( { dealerCriteria: JSON.parse(JSON.stringify(this.dealerCriteria)) }));
     
  }

  submitSearchForm(): void {

      let crt = JSON.parse(JSON.stringify(this.dealerCriteria));

      crt.pageNumber = 0;

      if(window.innerWidth <= AppConstants.SCREEN_BREAK_L ){
        this.showCriteriaPanel = false;
      }

      this.router.navigate(
        ['/keep/search'],
        { queryParams: crt }
      );
    
  }

  resetSearch(): void {

    this.dealerCriteria = new DealerCriteria();
    let crt = JSON.parse(JSON.stringify(this.dealerCriteria));
    this.store.dispatch(SearchActions.dealersPreviewCriteriaSubmit( { dealerCriteria: crt }));
  }

  saveAlert(): void {

    let crt: DealerCriteria = JSON.parse(JSON.stringify(this.dealerCriteria));
    console.log(crt);

    this.store.dispatch(DealerActions.addNewAlertSubmit({ criteria: crt }));
    alert("search will be added to your alerts");

  }

  toggleShowCriteria(): void{
    this.showCriteriaPanel = !this.showCriteriaPanel;
  }

  onResize(event: any) {
    //this.updateShowCriteria();
  }

  updateShowCriteria(){
    if(window.innerWidth > AppConstants.SCREEN_BREAK_L){
      this.showCriteriaPanel = true;
    }
    else{
      this.showCriteriaPanel = false;
    }  
  }

  updateCountries(event: any){

    this.dealerCriteria.countries = event.value;
    this.selectedCountryCodes = event.value;
    this.updateCitiesSelector();
    //this.store.dispatch(SearchActions.changeSelectedCountriesSubmit({ countryCodes: event.value}));
    this.onCriteriaChange();
  }


  onSelectedDatesChange(event: any){

    //console.log('hellooo '+event.value);
    if(this.dealerCriteria.maxCreatedDate != null &&  this.dealerCriteria.maxCreatedDate !== ""){
      //console.log('start '+ this.dealerCriteria.startDate);
      //console.log('end '+ this.dealerCriteria.endDate);
      this.onCriteriaChange();
    }
    
  }

  filterPastDates = (date: Date): boolean => {

    if ( ! (date > this.yesterdayDate) ) {
      return false;
    } 

    return true;
  }

}
